import * as React from 'react';
import {DataBtnSelect} from '../../../components/ui/DataBtnSelect';
import {DataMultiBtnSelect} from '../../../components/ui/DataMultiBtnSelect';
import { ProjectsDataSource, YearlyPeriodsDataSource, MonthlyPeriodsDataSource, HierarchyDataSource } from '../../../components/ui/FiltersBar/DataSources';
import { userData } from '../../../util/userData';
import { IReportProps, IFilter } from '../interfaces';
import { PeriodsFilter } from 'components/ui/FiltersBar/components/PeriodsFilter';

interface IReportState {
  isLoading: boolean
  filters: IFilter[]
  hierarchyValues: string[]
  periodFilters: string[]
}

export class Report extends React.Component<IReportProps, IReportState> {

  state: IReportState = {
    isLoading: false,
    filters: [],
    hierarchyValues: [],
    periodFilters: []
  }

  componentWillMount() {
    this.setState({ filters: this.props.report.filters })
  }

  componentWillReceiveProps(nextProps, prevState) {
    this.setState({ filters: nextProps.report.filters })
  }

  runReport() {
    const { report } = this.props
    const { filters } = this.state
    let isLoading = true
    this.setState({ isLoading })
    const client = userData.getUserDataFromSession('current_project')
    const version = userData.getUserDataFromSession('token').version
    const sessionKey = userData.getUserDataFromSession('token').session
    const userId = userData.getUserDataFromSession('token').userId

    let f = []
    filters.forEach(element => {
      const id = element.filterKey
      let value = ''
      if (element.filterType === 'yearly') {
        const pieces = element.value.split('YTD')
        value = pieces[0]
        f.push({ id, value })
      } else if (element.filterType === 'monthly') {
        const pieces = element.value.split('M')
        f.push({ id: 'month', value: pieces[1] })
        f.push({ id: 'year', value: pieces[0] })
      } else {
        value = element.value
        f.push({ id, value })
      }
    });

    const request = { objectKey: report.objectkey, version, client, sessionKey, user_id: userId, outputFormat: 'XLSX', filters: f }
    const method = 'POST'
    const body = JSON.stringify(request)
    const httpRequest = new XMLHttpRequest()
    httpRequest.open(method, 'https://zu6g20fbq6.execute-api.us-east-1.amazonaws.com/Dev/runreportv2', true)
    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

    httpRequest.responseType = 'blob';
    //HACK to update state after http request is loaded.
    // tslint:disable-next-line:no-this-assignment
    const self = this
    httpRequest.onload = function () {
      isLoading = false
      self.setState({ isLoading })
      if (this.status === 200) {
        const blob = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob) {
          // @ts-ignore
          window.navigator.msSaveBlob(blob, report.filename);
        } else {
          const downloadLink = window.document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = report.filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      }
    };
    httpRequest.onerror = function () {
      isLoading = false
      self.setState({ isLoading })
      alert('Error downloading report. Sorry for the inconvenience.')
    }
    httpRequest.send(body);
  }


  renderYearly(key) {
    const { filters } = this.state

    const filterIndex = filters.findIndex((value) => {
      return value.filterKey === key
    })

    return (
      <DataBtnSelect
        persistLabel
        groupMode
        key={key + filters[filterIndex].filterType}
        useMobileMode={false}
        source={YearlyPeriodsDataSource}
        value={filters[filterIndex].value}
        defaultValue={userData.getFilters().period}
        onChange={(periodValue) => {
          filters[filterIndex].value = periodValue
          this.setState({ filters })
        }}
        header="Year"
      />
    )
  }

  renderProject(key) {
    const { filters } = this.state

    const filterIndex = filters.findIndex((value) => {
      return value.filterKey === key
    })

    return (
      <DataBtnSelect
        persistLabel={true}
        useMobileMode={false}
        key={key + filters[filterIndex].filterType}
        clearable
        source={ProjectsDataSource}
        value={filters[filterIndex].value}
        defaultValue={userData.getCurrentProject()}
        onChange={(projectValue) => {
          filters[filterIndex].value = projectValue
          this.setState({ filters })
        }}
        header="Project" />
    )
  }

  renderMonthly(key) {
    const { filters } = this.state

    const filterIndex = filters.findIndex((value) => {
      return value.filterKey === key
    })

    return (
      <DataBtnSelect
        key={key + filters[filterIndex].filterType}
        persistLabel
        groupMode
        useMobileMode={false}
        source={MonthlyPeriodsDataSource}
        value={filters[filterIndex].value}
        defaultValue={userData.getFilters().period}
        onChange={(periodValue) => {
          filters[filterIndex].value = periodValue
          this.setState({ filters })
        }}
        header="Month"
      />
    )
  }

  renderPeriod(key) {
    const { filters } = this.state

    const filterIndex = filters.findIndex((value) => {
      return value.filterKey === key
    })

    return (
      <PeriodsFilter
        useMobileMode={false}
        values={this.state.periodFilters}
        defaultValue={userData.getFilters().period}
        onChange={(periodValues) => {
          let filterValue

          if (Array.isArray(periodValues)) {
            filterValue = [...periodValues].pop() //get latest value for filter save
          } else {
            filterValue = periodValues
          }

          filters[filterIndex].value = filterValue
          this.setState({ filters, periodFilters: periodValues })
        }}
      />
    )
  }

  renderHierarchy(key) {
    const { filters } = this.state

    const filterIndex = filters.findIndex((value) => {
      return value.filterKey === key
    })

    return (
      <DataMultiBtnSelect
        placeholder="Hierarchy"
        source={HierarchyDataSource}
        key={key}
        hidePopoverOnClear
        hidePopoverOnLeadNodeSelect
        useMobileMode={false}
        persistLabel={true}
        disableClearOnFirstSelect
        showAllCoachingFormOption={false}
        defaultValue={userData.getFilters().hier}
        values={this.state.hierarchyValues}
        onChange={(hierarchyValues) => {
          let filterValue

          if (Array.isArray(hierarchyValues)) {
            filterValue = [...hierarchyValues].pop() //get latest value for filter save
          } else {
            filterValue = hierarchyValues
          }

          filters[filterIndex].value = filterValue
          this.setState({ filters, hierarchyValues })
        }}
        hideFirstSelectWhen={(source) => source.length >= 1 && source[0].value.toLowerCase() === 'bankwide_0'}
      />
    )
  }

  renderFilters() {
    const { report } = this.props

    let displayFilters = []
    report.filters.forEach(element => {
      if (element.filterType === 'yearly') {
        displayFilters.push(this.renderYearly(element.filterKey))
      }
      if (element.filterType === 'monthly') {
        displayFilters.push(this.renderMonthly(element.filterKey))
      }
      if (element.filterType === 'project') {
        displayFilters.push(this.renderProject(element.filterKey))
      }
      if (element.filterType === 'hierarchy') {
        displayFilters.push(this.renderHierarchy(element.filterKey))
      }
      if (element.filterType === 'period') {
        displayFilters.push(this.renderPeriod(element.filterKey))
      }
    });

    return displayFilters
  }

  render() {
    const { report } = this.props
    const { isLoading } = this.state
    return (
      <section>
        <h3>{report.name}<a className="right link" onClick={() => this.runReport()}><img src="images/excel_32.png"></img></a></h3>
        <section className="filtersv2">
          <section className="blacklight filters-bar-container">
            <section className="container-old filters-bar">
              {this.renderFilters()}
            </section>
          </section>
        </section>
        {
          isLoading
            ?
            <div>
              <img src="images/loading.gif" alt="Loading..." />
            </div>
            : null}
      </section>
    )
  }
}
